import { useRequest } from "@prismicio/editor-support/Suspense"

import { getDocumentUrl } from "../../../../core/document"
import { getDocumentByDocumentId } from "../../../../core/service"
import { throwConfigError, useEditorConfig } from "../../../../EditorConfig"
import { LinkDescriptionCard } from "../../../LinkField"

interface DocumentDescriptionCardProps {
  docId: string
  onEdit: () => void
  onUnlink: () => void
}

export function DocumentDescriptionCard(props: DocumentDescriptionCardProps) {
  const { docId, onEdit, onUnlink } = props
  const document = useDocumentData(docId)
  const config = useEditorConfig()

  if (!document) return null

  const latestVersion = document.versions[0]

  const documentUrl = getDocumentUrl({
    status: latestVersion?.status,
    releaseId:
      latestVersion?.status === "release"
        ? latestVersion.release_id
        : undefined,
    documentId: document.id,
    versionId: latestVersion?.version_id,
    baseUrl: config.baseUrl
  })

  const documentDescription = latestVersion?.preview_summary ?? ""

  const documentType = latestVersion?.custom_type_label ?? ""

  return (
    <LinkDescriptionCard
      url={documentUrl}
      title={document.title}
      subTitle={documentType}
      description={documentDescription}
      onEdit={onEdit}
      onUnlink={onUnlink}
      largeIconName="description"
    />
  )
}

function useDocumentData(id: string) {
  const config = useEditorConfig()

  if (!config.searchDocuments) throwConfigError("searchDocuments")

  const { coreApiBaseUrl, authStrategy } = config

  return useRequest(getDocumentByDocumentId, [coreApiBaseUrl, authStrategy, id])
}
